import { isClient } from '@/utilities';
import { type BrowserHistory, createBrowserHistory } from 'history';

export interface QueryStringClient {
  get: () => string;
  getValue: (queryParamName: string) => string | null;
  set: (value: string) => void;
  remove: (queryParamName: string) => void;
}

export function createQueryStringClient(initialBrowserHistory?: BrowserHistory): QueryStringClient {
  let browserHistory: BrowserHistory;
  if (isClient()) {
    browserHistory = initialBrowserHistory || createBrowserHistory();
  }

  function get() {
    if (!browserHistory) return '';

    return browserHistory.location.search;
  }

  function set(queryString: string) {
    if (!browserHistory) return;

    browserHistory.push({
      pathname: window.location.pathname,
      search: `?${queryString}`,
    });
  }

  function getValue(queryParamName: string): string | null {
    const paramValue = new URLSearchParams(get()).get(queryParamName);
    return paramValue || null;
  }

  function remove(queryParamName: string) {
    const urlParams = new URLSearchParams(get());
    urlParams.delete(queryParamName);
    browserHistory.replace(`${window.location.pathname}?${urlParams.toString()}`);
  }

  return { get, set, getValue, remove };
}

export default createQueryStringClient();
